import {Button, CircularProgress} from '@mui/material';

export interface ModuleViewActionButtonProps {
  label: string;
  onClick: () => void;
  loading: boolean;
  disabled?: boolean;
  bgcolor: string;
  variant?: 'contained' | 'outlined';
  progressColor?: string;
}

export default function ModuleViewActionButton({
  label,
  onClick,
  loading,
  disabled,
  bgcolor,
  variant = 'contained',
  progressColor = 'white',
}: ModuleViewActionButtonProps) {
  return (
    <Button
      variant={variant}
      size="medium"
      disabled={disabled || loading}
      onClick={onClick}
      sx={{
        bgcolor: variant === 'contained' ? bgcolor : 'transparent',
        borderColor: variant === 'outlined' ? bgcolor : undefined,
        color: variant === 'outlined' ? bgcolor : 'white',
        '&:hover': {
          bgcolor: variant === 'contained' ? bgcolor : '#f5f5f5',
          opacity: variant === 'contained' ? 0.8 : 1,
          borderColor: variant === 'outlined' ? bgcolor : undefined,
        },
        '&:disabled': {bgcolor: '#ccc', color: '#666', borderColor: '#ccc'},
        fontWeight: 600,
        px: 3,
        py: 1,
        position: 'relative',
        minHeight: '40px',
      }}
    >
      {loading ? (
        <CircularProgress
          size={20}
          sx={{
            color: progressColor,
            position: 'absolute',
          }}
        />
      ) : (
        label
      )}
    </Button>
  );
}
